import { createFileRoute } from '@tanstack/react-router'
import { AdminMarketingOverview } from '@/components/admin/marketing/AdminMarketingOverview'

// The detailed marketing numbers — KPIs, engagement, customer mix, top
// performers, live activity. Was the Overview until F-MKT-N1.
export const Route = createFileRoute('/admin/marketing/performance')({
  component: () => <AdminMarketingOverview />,
})
